import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";

import { WebTrackerReportTrackerStats } from "../types";

const useStyles = makeStyles((_) => ({
  pageURL: {
    textDecoration: "underline",
  },
  tableBodyCell: {
    borderBottom: "none",
  },
  viewPagesButton: {
    float: "right",
  },
}));

export type ExamplePagesTableProps = {
  webTrackerStats: WebTrackerReportTrackerStats;
};

function ExamplePagesTable({ webTrackerStats }: ExamplePagesTableProps) {
  const classes = useStyles();

  if (webTrackerStats.examplePages.length === 0) {
    return <></>;
  }

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Example Pages</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {webTrackerStats.examplePages.map((pg, idx) => {
            return (
              <TableRow key={`example-page-${pg.pageURL}`}>
                <TableCell className={classes.tableBodyCell}>
                  <div>
                    <Typography component="h4" variant="body1">
                      <span>{idx + 1}.</span> {pg.pageTitle}
                    </Typography>{" "}
                  </div>
                  <a
                    target="_blank"
                    rel="noreferrer nofollow"
                    href={pg.pageURL}
                  >
                    <Typography
                      className={classes.pageURL}
                      component="p"
                      variant="body2"
                    >
                      {pg.pageURL}
                    </Typography>
                  </a>
                </TableCell>
                <TableCell className={classes.tableBodyCell}>
                  <Button
                    className={classes.viewPagesButton}
                    color="primary"
                    title={pg.pageTitle}
                    variant="outlined"
                  >
                    <Link
                      target="_blank"
                      color="primary"
                      href={pg.pageURL}
                      rel="noreferrer nofollow"
                      title={pg.pageTitle}
                      variant="body2"
                      underline="none"
                    >
                      View Page
                    </Link>
                  </Button>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ExamplePagesTable;
